/*
 * Modules-load.ts
 * Description: Defining vuex load objects for storing data
 */

// Defining module to store the loading param
export const moduleLoading = {
    state: {
        loading: true,
    },
    mutations: {
        SET_LOADING_ON(state) {
            state.loading = true;
        },
        SET_LOADING_OFF(state) {
            state.loading = false;
        },
    },
    actions: {
        setLoadingOn({commit, state}) {
            commit('SET_LOADING_ON');
        },
        setLoadingOff({commit, state}) {
            commit('SET_LOADING_OFF');
        },
    },
    getters: {
        loading(state) {
            return state.loading;
        },
    },
};

export const moduleQueryParam = {
    state: {
        query_param: '',
    },
    mutations: {
        SET_QUERY_PARAM(state, data) {
            state.query_param = data;
        },
    },
    actions: {
        setQueryParam({commit, state}, data) {
            commit('SET_QUERY_PARAM', data);
        },
    },
    getters: {
        queryParam(state) {
            return state.query_param;
        },
    },
};

export const moduleSortParam = {
    state: {
        sort_param: '',
    },
    mutations: {
        SET_SORT_PARAM(state, data) {
            state.sort_param = data;
        },
    },
    actions: {
        setSortParam({commit, state}, data) {
            commit('SET_SORT_PARAM', data);
        },
    },
    getters: {
        sortParam(state) {
            return state.sort_param;
        },
    },
};

export const moduleOrderParam = {
    state: {
        order_param: '',
    },
    mutations: {
        SET_ORDER_PARAM(state, data) {
            state.order_param = data;
        },
    },
    actions: {
        setOrderParam({commit, state}, data) {
            commit('SET_ORDER_PARAM', data);
        },
    },
    getters: {
        orderParam(state) {
            return state.order_param;
        },
    },
};
